const categoryTypes = {
  GET_CATEGORIES_REQUEST: "GET_CATEGORIES_REQUEST",
  GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILED: "GET_CATEGORIES_FAILED",
};

export default categoryTypes;
